/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var h = require("@lexical/link"),
    n = require("@lexical/react/LexicalComposerContext"),
    p = require("@lexical/utils"),
    u = require("lexical"),
    w = require("react");

function A(a) {
  var b = new URLSearchParams();
  b.append("code", a);

  for (var c = 1; c < arguments.length; c++) {
    b.append("v", arguments[c]);
  }

  throw Error("Minified Lexical error #".concat(a, "; visit https://lexical.dev/docs/error?").concat(b, " for the full message or ") + "use the non-minified dev environment for full errors and additional helpful warnings.");
}

function B(a, b) {
  for (var c = 0; c < b.length; c++) {
    var d = b[c](a);
    if (d) return d;
  }

  return null;
}

var C = /[.,;\s]/;

function E(a) {
  a = a.getPreviousSibling();
  u.$isElementNode(a) && (a = a.getLastDescendant());
  var b;
  !(b = null === a || u.$isLineBreakNode(a)) && (b = u.$isTextNode(a)) && (a = a.getTextContent(), b = C.test(a[a.length - 1]));
  return b;
}

function F(a) {
  a = a.getNextSibling();
  u.$isElementNode(a) && (a = a.getFirstDescendant());
  return null === a || u.$isLineBreakNode(a) || u.$isTextNode(a) && C.test(a.getTextContent()[0]);
}

function G(a, b, c) {
  var d = a.getChildren();
  var e = d.length;

  for (var f = 0; f < e; f++) {
    var l = d[f];

    if (!u.$isTextNode(l) || !l.isSimpleText()) {
      H(a);
      c(null, a.getURL());
      return;
    }
  }

  d = a.getTextContent();
  b = B(d, b);
  null === b || b.text !== d ? (H(a), c(null, a.getURL())) : E(a) && F(a) ? (d = a.getURL(), d !== b.url && (a.setURL(b.url), c(b.url, d)), b.attributes && (d = a.getRel(), d !== b.attributes.rel && (a.setRel(b.attributes.rel || null), c(b.attributes.rel || null, d)), d = a.getTarget(), d !== b.attributes.target && (a.setTarget(b.attributes.target || null), c(b.attributes.target || null, d)))) : (H(a), c(null, a.getURL()));
}

function H(a) {
  var b = a.getChildren();
  var c = b.length;

  for (--c; 0 <= c; c--) {
    a.insertAfter(b[c]);
  }

  a.remove();
  return b.map(function (d) {
    return d.getLatest();
  });
}

function I(a, b, c) {
  w.useEffect(function () {
    a.hasNodes([h.AutoLinkNode]) || A(77);

    var d = function d(e, f) {
      c && c(e, f);
    };

    return p.mergeRegister(a.registerNodeTransform(u.TextNode, function (e) {
      var f = e.getParentOrThrow(),
          l = e.getPreviousSibling();
      if (h.$isAutoLinkNode(f)) G(f, b, d);else if (!h.$isLinkNode(f)) {
        if (e.isSimpleText() && (C.test(e.getTextContent()[0]) || !h.$isAutoLinkNode(l))) {
          l = f = e.getTextContent();
          var m = 0,
              v = e;

          for (var g; (g = B(l, b)) && null !== g;) {
            var r = g.index,
                x = g.length,
                y = r + x;
            var t = m + r,
                q = m + y,
                z = f,
                D = e;

            if ((0 < t ? C.test(z[t - 1]) : E(D)) && (q < z.length ? C.test(z[q]) : F(D))) {
              var _v$splitText, _v$splitText2, _v$splitText3, _v$splitText4;

              var k = void 0;
              0 === m + r ? (_v$splitText = v.splitText(m + x), _v$splitText2 = _slicedToArray(_v$splitText, 2), k = _v$splitText2[0], v = _v$splitText2[1], _v$splitText) : (_v$splitText3 = v.splitText(m + r, m + r + x), _v$splitText4 = _slicedToArray(_v$splitText3, 3), k = _v$splitText4[1], v = _v$splitText4[2], _v$splitText3);
              t = h.$createAutoLinkNode(g.url, g.attributes);
              q = u.$createTextNode(g.text);
              q.setFormat(k.getFormat());
              q.setDetail(k.getDetail());
              t.append(q);
              k.replace(t);
              c && c(g.url, null);
              m = 0;
            } else m += y;

            l = l.substring(y);
          }
        }

        f = e.getPreviousSibling();
        g = e.getNextSibling();
        k = e.getTextContent();
        h.$isAutoLinkNode(f) && !C.test(k[0]) && (f.append(e), G(f, b, d), e = f.getURL(), c && c(null, e));
        h.$isAutoLinkNode(g) && !C.test(k[k.length - 1]) && (H(g), G(g, b, d), e = g.getURL(), c && c(null, e));
      }
    }));
  }, [a, b, c]);
}

exports.AutoLinkPlugin = function (_ref) {
  var a = _ref.matchers,
      b = _ref.onChange;

  var _n$useLexicalComposer = n.useLexicalComposerContext(),
      _n$useLexicalComposer2 = _slicedToArray(_n$useLexicalComposer, 1),
      c = _n$useLexicalComposer2[0];

  I(c, a, b);
  return null;
};

exports.createLinkMatcherWithRegExp = function (a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (c) {
    return c;
  };
  return function (c) {
    var d = a.exec(c);
    return null === d ? null : {
      index: d.index,
      length: d[0].length,
      text: d[0],
      url: b(c)
    };
  };
};